import { NotificationTypes, VoyNotification } from "../services/types/vessel-notifications-services.types";
import { BaseModel } from "./base-model";

export abstract class ImminentRiskModelBase extends BaseModel {
    abstract getCurrentImminentRiskAlert(): Promise<ImminentRiskType | null>;
    abstract fetchImminentRiskOnboard(): Promise<boolean>;
    abstract finishOnboarding(audioHeard: boolean): Promise<void>;
    abstract finishTesting(audioHeard: boolean): Promise<void>;
}

let ImminentRiskModel: ImminentRiskModelBase|null = null;

function setImminentRiskModel(model: ImminentRiskModelBase){
    ImminentRiskModel = model;
}

export type ImminentRiskType = VoyNotification<NotificationTypes.ImminentRisk>;
export { ImminentRiskModel, setImminentRiskModel };